<template>
  <div id="help">
      <h2>Aide</h2>
      <p>Version cineserver: {{serverversion}}</p>
      <p>Version cinegest: {{$store.state.version}}</p>
  </div>
</template>

<script>
import api from '@/api'

export default {
  data() {
    return {
      serverversion: undefined
    }
  },
  async created() {
    this.serverversion = (await api.getInfo()).data.version;
  },

}

</script>